import { render, staticRenderFns } from "./MagazzinoArticoliListComponent.vue?vue&type=template&id=40244a2b&scoped=true"
import script from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliListComponent.vue?vue&type=script&lang=js"
import style0 from "./MagazzinoArticoliListComponent.vue?vue&type=style&index=0&id=40244a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40244a2b",
  null
  
)

export default component.exports